import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CampaignCompletionRefreshService {
  private completionRefreshCallbacks = new Map<string, (campaignId: number) => Promise<void>>();

  /**
   * Register a callback to be called when completion data needs to be refreshed
   */
  registerRefreshCallback(key: string, callback: (campaignId: number) => Promise<void>): void {
    this.completionRefreshCallbacks.set(key, callback);
  }

  /**
   * Unregister a callback
   */
  unregisterRefreshCallback(key: string): void {
    this.completionRefreshCallbacks.delete(key);
  }

  /**
   * Trigger refresh of completion data for a specific campaign
   */
  async refreshCompletionForCampaign(campaignId: number): Promise<void> {
    // Call all registered callbacks
    const promises = Array.from(this.completionRefreshCallbacks.values()).map(callback =>
      callback(campaignId).catch(error => {
        console.error('Error in completion refresh callback:', error);
      }),
    );

    await Promise.all(promises);
  }
}
